import { PortfolioLoadingSkeleton } from '@/components/portfolio/portfolio-loading-skeleton';

// Route-level Suspense fallback for `/portfolio/[user_id]` — shown while
// the RSC `page.tsx` awaits `buildOtherPortfolioPrefetch`. Uses the
// `'other'` PnL variant so CLS stays aligned with `<OtherPortfolio>`;
// the dispatcher still upgrades to `'own'` chrome client-side once auth
// resolves and the viewer is identified as themselves.
export default function PublicPortfolioLoading(): React.ReactNode {
  return <PortfolioLoadingSkeleton pnlViewerMode="other" />;
}
